import React from "react";
import {
  expiryStatusoptions,
  scheduleoptions,
  stockInOutOptions,
} from "../../helper-components/data";
import FilterRadioButtons from "../../forms/filter-radio-buttons";
import AddButton from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";

const StockDetailsFilter = ({ setFilterData, filterData, initFilter = {} }) => {
  const handleStockStatusChange = (e) => {
    setFilterData({
      ...filterData,
      stock_status: e.target.value,
    });
  };
   
  const handleExpiryStatusChange = (e) => {
    setFilterData({
      ...filterData,
      expiry_status: e.target.value,
    });
  };
  const handleDrugsChange = (e) => {
    setFilterData({
      ...filterData,
      rx_drugs: e.target.value,
    });
  };

  return (
    <div
      menuPortalTarget={document.body}
      style={{
        minWidth: "20rem",
        maxWidth: "20rem",
        zIndex: 999,
        top: "50px",
        right: "-5px",
        boxShadow: `0 12px 32px -8px var(--popover-shadow-color), 0 2px 6px -2px var(--popover-shadow-color)`,
      }}
      className="absolute  border border-[var(--popover-border-color)] border-solid border-1   py-3 px-2  bg-[var(--popover-bg-color)]  rounded-xl z-10 flex flex-col"
    >
      <span className=" text-[length:--popover-h1-fs] font-[var(--popover-heading-font-weight)] text-[var(--popover-heading-fg-color)] whitespace-nowrap cursor-pointer border-radius px-[8px] py-[12px]">
        Filter
      </span>
      <p className=" text-[length:--popover-desc-font-size] font-[var(--popover-desc-font-weight)] text-[var(--popover-desc-fg-color)] whitespace-nowrap cursor-pointer border-radius px-[8px] pb-[12px]">
        Narrow down your search results
      </p>
      <div className="">
        <FilterRadioButtons
          valueclass="flex gap-5 items-center"
          name="stock_status"
          label={"Status"}
          options={stockInOutOptions}
          handleChange={handleStockStatusChange}
          value={filterData?.stock_status}
        />
        <hr className="border-0 border-t border-[var(--popover-border-color)] mx-1" />
        <FilterRadioButtons
          subClass="flex  items-center w-[45%]"
          valueclass="flex gap-[10px]  items-center flex-wrap"
          name="expiry_status"
          label={"Expiry Status"}
          options={expiryStatusoptions}
          handleChange={handleExpiryStatusChange}
          value={filterData?.expiry_status}
        />
        <hr className="border-0 border-t border-[var(--popover-border-color)] mx-1" />
        <FilterRadioButtons
          subClass="flex  items-center w-[45%]"
          valueclass="flex gap-[10px]  items-center flex-wrap"
          name="rx_drugs"
          label={"Rx Drugs"}
          options={scheduleoptions}
          handleChange={handleDrugsChange}
          value={filterData?.rx_drugs}
        />
      </div>
      <AddButton
        onclkFn={() => {
          setFilterData(initFilter);
        }}
        icon={<CloseIcon />}
        text={<>Clear Filters</>}
        className={`flex items-center px-[12px] h-[40px] whitespace-nowrap rounded-[8px] gap-[8px]
    bg-[var(--general-button-bg)] cursor-pointer 
    border border-[var(--general-button-border)] 
    hover:bg-[var(--general-button-bg)]
    font-[var(--general-button-fw)]
    text-[var(--general-button-fg)]
    justify-center mt-[1rem]
    `}
      />
    </div>
  );
};

export default StockDetailsFilter;
